import { useState } from 'react';
import Button from '../../Button';
import Modal from '..';

const Confirm = ({
  title,
  subtitle,
  message,
  accept,
  decline,
  content,
  acceptButtonLabel,
  declineButtonLabel,
}: {
  title: string;
  subtitle?: string;
  message?: string;
  content?: React.ReactNode;
  accept: () => Promise<void> | void;
  decline: () => void;
  acceptButtonLabel: string;
  declineButtonLabel: string;
}) => {
  const [accepting, setAccepting] = useState<boolean>(false);
  const handleClick = async () => {
    setAccepting(true);
    try {
      await accept();
    } finally {
      setAccepting(false);
    }
  };
  return (
    <Modal>
      <h2 className='m-0 capitalize'>{title}</h2>
      <h4 className='mt-4'>{subtitle}</h4>
      {content ? content : <p className='mt-4 text-sm'>{message}</p>}
      <div className='flex justify-end gap-4 mt-5'>
        <Button disabled={accepting} label={declineButtonLabel} btnStyle='btn-neutral' onClick={decline} />
        <Button
          label={accepting ? 'Please wait ...' : acceptButtonLabel}
          disabled={accepting}
          btnStyle='btn-tertiary'
          onClick={handleClick}
        />
      </div>
    </Modal>
  );
};

export default Confirm;
